// File: src/data/constants.js
// نسخه سازگار با توسعه لوکال — localhost به API سرور واقعی وصل می‌شود

// ── حالت توسعه لوکال ──
// true  = روی لوکال هم به سرور واقعی tehranaa.org وصل شو (نیازی به XAMPP/API لوکال نیست)
// false = روی لوکال به API لوکال (localhost/tehranaa) وصل شو
const USE_REMOTE_API_ON_LOCAL = true;

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// ── آدرس پایه API ──
export const API_BASE =
  (isLocal && !USE_REMOTE_API_ON_LOCAL)
    ? 'http://localhost/tehranaa/api/meetings.php'
    : 'https://tehranaa.org/meetings/api/meetings.php';

export const API_SETTINGS =
  (isLocal && !USE_REMOTE_API_ON_LOCAL)
    ? 'http://localhost/tehranaa/api/settings.php'
    : 'https://tehranaa.org/meetings/api/settings.php';

// ── روزهای هفته ──
export const DAYS_OF_WEEK = [
  { id: 1, name: 'شنبه',     short: 'ش' },
  { id: 2, name: 'یکشنبه',  short: 'ی' },
  { id: 3, name: 'دوشنبه',  short: 'د' },
  { id: 4, name: 'سه‌شنبه', short: 'س' },
  { id: 5, name: 'چهارشنبه',short: 'چ' },
  { id: 6, name: 'پنج‌شنبه',short: 'پ' },
  { id: 7, name: 'جمعه',    short: 'ج' },
];

export const GENDER_TYPES = [
  { id: 'mixed',  name: 'مختلط',  icon: '👥', color: '#38bdf8' },
  { id: 'men',    name: 'آقایان', icon: '👔', color: '#60a5fa' },
  { id: 'women',  name: 'بانوان', icon: '👗', color: '#f472b6' },
];

export const MEETING_TYPES = [
  { id: 'physical', name: 'حضوری', icon: '🏠', color: '#34d399' },
  { id: 'virtual',  name: 'مجازی', icon: '💻', color: '#a78bfa' },
];

export const FACILITIES = {
  parking:      { icon: '🅿️', label: 'پارکینگ' },
  wheelchair:   { icon: '♿',  label: 'ویلچر' },
  outdoor:      { icon: '🌳', label: 'فضای باز' },
  indoor:       { icon: '🏠', label: 'سرپوشیده' },
  metro_nearby: { icon: '🚇', label: 'نزدیک مترو' },
  prayer_room:  { icon: '🕌', label: 'نمازخانه' },
  kids_area:    { icon: '👶', label: 'فضای کودک' },
};

export const ALERT_TYPES = {
  cancellation:    { icon: '❌', label: 'لغو جلسه',      color: '#ef4444' },
  postpone:        { icon: '⏳', label: 'تعویق',          color: '#f59e0b' },
  location_change: { icon: '📍', label: 'تغییر مکان',    color: '#8b5cf6' },
  time_change:     { icon: '🕐', label: 'تغییر ساعت',    color: '#06b6d4' },
  info:            { icon: 'ℹ️', label: 'اطلاع‌رسانی',   color: '#3b82f6' },
};

export const toPersian = (v) =>
  String(v).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d]);

export const getIranNow = () =>
  new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tehran', hour12: false }));

export const getIranDayOfWeek = (date) =>
  [2, 3, 4, 5, 6, 7, 1][date.getDay()];

export const safeGet = (key, fb = []) => {
  try { return JSON.parse(localStorage.getItem(key)) ?? fb; } catch { return fb; }
};
export const safeSet = (key, val) => {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
};

export function clearOldCaches() {
  try {
    const toDelete = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      const valid = ['aa_v3_lite', 'aa_v2_provinces'];
      const isMeetingCache = k && (k.startsWith('aa_cache_') || /^aa_v\d+_/.test(k) || k === 'aa_v2_all');
      if (isMeetingCache && !valid.includes(k)) toDelete.push(k);
    }
    toDelete.forEach(k => localStorage.removeItem(k));
    if (toDelete.length) console.log('[Cache] Cleared', toDelete.length, 'old cache entries');
  } catch {}
}

export const buildApiUrl = (params = {}) => {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.set(k, v);
  });
  return `${API_BASE}?${p.toString()}`;
};

export function isFastDevice() {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    const cores = navigator.hardwareConcurrency || 2;
    const mem   = navigator.deviceMemory || 2;
    const conn  = navigator.connection;
    const slowNet = conn && /(^|-)2g$/.test(conn.effectiveType || '');
    if (slowNet) return false;
    return cores >= 4 && mem >= 4;
  } catch {
    return false;
  }
}
